import React, { useEffect, useRef, useState } from 'react';

import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  Divider,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  modal: {
    zIndex: '10002 !important',
  },
  paper: {
    borderRadius: '12px',
    boxShadow:
      '0px 2px 4px rgba(0, 0, 0, 0.2), 0px 0px 20px rgba(0, 0, 0, 0.15)',
    minWidth: '448px',
  },
  dialogTitle: {
    padding: '16px 24px',
    '& > h2': {
      fontWeight: 800,
      fontSize: '16px',
      lineHeight: '32px',
      color: '#333333',
    },
  },
  dialogContent: {
    padding: '0px 24px 16px 24px',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#333333',
  },
  button: {
    fontWeight: '600',
    fontSize: '14px',
    textTransform: 'none',
    '&:hover': {
      background: 'rgba(86, 94, 237, 0.08)',
    },
    '&:disabled': {
      opacity: 0.6,
      color: '#E24F4F !important'
    }
  },
  deleteButton: {
    '&.kt-spinner': {
      '&:after': {
        content: '""',
        display: 'inline-block',
        width: '12px',
        height: '12px',
        marginLeft: '8px',
        verticalAlign: 'middle',
        border: '2px solid #E24F4F',
        borderRadius: '50%',
        borderRight: '2px solid transparent',
        animation: '$spin 0.5s linear infinite'
      }
    }
  },
  '@keyframes spin': {
    to: {
      transform: 'rotate(360deg)'
    }
  }
}));

export const ModalConfirm = (props) => {
  const classes = useStyles();

  const [disabled, setDisabled] = useState(false);
  const reenableTimerRef = useRef();

  const {
    open,
    title,
    summary,
    handleCancel,
    handleConfirm,
    confirmTitle,
    applyButton,
    loading,
  } = props;

  useEffect(() => {
    return () => {
      if (reenableTimerRef.current) {
        clearTimeout(reenableTimerRef.current);
      }
    };
  }, []);

  const handleClick = () => {
    setDisabled(true);
    handleConfirm();
    if (reenableTimerRef.current) {
      clearTimeout(reenableTimerRef.current);
    }
    reenableTimerRef.current = setTimeout(() => {
      setDisabled(false);
      reenableTimerRef.current = undefined;
    }, 1000);
  };

  return (
    <Dialog
      id="modal-confirm-dialog"
      open={open}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      style={{ alignItems: 'start' }}
      classes={{ paper: classes.paper, root: classes.modal }}
    >
      <DialogTitle
        id="alert-dialog-title"
        classes={{ root: classes.dialogTitle }}
      >
        {title}
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <DialogContentText
          id="alert-dialog-description"
          style={{ marginBottom: 0 }}
        >
          {summary}
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions style={{ padding: '16px 20px 16px 16px' }}>
        <Button
          id="cancel-button"
          onClick={handleCancel}
          classes={{ root: classes.button }}
          style={{
            color: '#333333',
          }}
        >
          Cancel
        </Button>
        {applyButton ? (
          applyButton
        ) : (
          <Button
            id="confirm-button"
            disabled={disabled || loading}
            onClick={handleClick}
            autoFocus
            classes={{ 
              root: `${classes.button} ${loading ? 'kt-spinner ' + classes.deleteButton : ''}`
            }}
            style={{
              color: '#E24F4F',
              minWidth: '80px',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {confirmTitle}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
